import { useEffect, useState } from 'react'

/** This custom hook watches a dom element for computed size changes.
 *
 * @param currentRef The dom element to observe for changes
 * @param trigger An optional value that is observed for manual changes.
 */
const useDomRectObserver = <R extends HTMLElement, T>(currentRef: R | null, trigger?: T): DOMRect | null => {
    const [rect, setRect] = useState<DOMRect | null>(currentRef?.getBoundingClientRect() ?? null)

    useEffect(() => {
        if (currentRef == null) {
            return setRect(null)
        }

        const element = currentRef
        const update = () => setRect(element.getBoundingClientRect())
        update()
        window.addEventListener('resize', update)
        return () => window.removeEventListener('resize', update)
    }, [currentRef, trigger])

    return rect
}

export default useDomRectObserver
